import React from 'react';
import { Form, Dropdown } from 'react-bootstrap';

const MultiSalesRepSelector = ({ 
  salesReps = [], 
  selectedIds = [], 
  onChange, 
  label = "Comercial",
  placeholder = "Todos los comerciales",
  disabled = false,
  testId = "multi-sales-rep-selector"
}) => {
  const handleToggle = (salesRepId) => {
    const newIds = selectedIds.includes(salesRepId)
      ? selectedIds.filter(id => id !== salesRepId)
      : [...selectedIds, salesRepId];
    onChange(newIds);
  };

  return (
    <Form.Group>
      <Form.Label>{label}</Form.Label>
      <Dropdown data-testid="multi-sales-rep-dropdown">
        <Dropdown.Toggle 
          variant="outline-secondary" 
          className="w-100 text-start"
          disabled={disabled}
          data-testid="multi-sales-rep-toggle"
        >
          {selectedIds.length === 0 ? placeholder : `${selectedIds.length} seleccionados`}
        </Dropdown.Toggle>
        <Dropdown.Menu style={{ maxHeight: '400px', overflowY: 'auto', width: 'max-content' }} data-testid="multi-sales-rep-menu">
          {salesReps.map(rep => (
            <Dropdown.Item key={rep.id} as="div" onClick={(e) => e.stopPropagation()}>
              <Form.Check
                type="checkbox"
                id={`salesrep-${rep.id}`}
                label={`${rep.name} ${rep.lastName1} (${rep.leadsCount || 0} leads)`}
                checked={selectedIds.includes(rep.id.toString())}
                onChange={() => handleToggle(rep.id.toString())}
                data-testid={`multi-sales-rep-checkbox-${rep.id}`}
                data-leads-count={rep.leadsCount || 0}
              />
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </Form.Group>
  );
};

export default MultiSalesRepSelector;